export const SUBTITLE_ADMIN_ACCESS_REQUIRED = 'Admin Access Required';

/** The public app's sign-in line, under "Welcome home". */
export const SUBTITLE_SIGN_IN_TO_CONTINUE = 'Sign in to continue';

export const SUBTITLE_SIGN_IN_TO_VIEW_ANALYTICS = 'Sign in to view analytics';

export const SUBTITLE_SIGN_IN_TO_VIEW_MARKET_MAKER = 'Sign in to view market maker';
